import { TextField } from "../../../components/ui/index.js";

import ComposerEnumParam from "./ComposerEnumParam.js";
import ComposerParamLabel from "./ComposerParamLabel.js";
import { type ComposerParamComponentProps } from "./index.js";

const ComposerStringParam = ({
  param,
  control,
  name,
}: ComposerParamComponentProps<"string">) => {
  if (param.enum) {
    return <ComposerEnumParam param={param} control={control} name={name} />;
  }

  return (
    <TextField
      control={control}
      name={name}
      label={param.name && <ComposerParamLabel unwrap param={param} />}
      formatValue={(value) => String(value || "")}
    />
  );
};

export default ComposerStringParam;
